import {SummaryFieldLabel} from './summary-field-label';

interface Props {
    label: string;
    children: React.ReactNode;
}

export function DataFieldWrapper(props: Props) {
    return (
        <>
            <SummaryFieldLabel>{props.label}</SummaryFieldLabel>
            <div className='full-width min-width-0'>{props.children}</div>
        </>
    );
}
